import { unwrapPayload } from '../../api/unwrap';
import { pick } from '../pick';

export const getProcurementMitraFirstItem = response => {
  const data = unwrapPayload(response);
  const items = data?.items ?? data?.Items;

  if (!Array.isArray(items) || items.length === 0) return null;
  return items[0];
};

export const getProcurementMitraId = item =>
  pick(item, 'id', 'Id') ??
  pick(item, 'procurementMitraId', 'ProcurementMitraId');
